/* eslint-disable no-unused-vars */
import Vue from 'vue';
import { Request, IS_PROD, Device } from '@/utils';
import WechatPlugin from 'vux/src/plugins/wechat/index.js'

import '../../pages/Invitation/assets/logo.png';

Vue.use(WechatPlugin);

const wx = Vue.wechat;

/* eslint-disable */
const isWechat = () => {
const ua = window.navigator.userAgent.toLowerCase();
if (ua.match(/MicroMessenger/i) == 'micromessenger') {
return true;
}

return false;
};

const  jsApiList= ['updateAppMessageShareData','hideAllNonBaseMenuItem', 'showAllNonBaseMenuItem','getLocation', 'closeWindow'];

const getAppId = () => {
if (!isWechat()) {
return new Promise((resolve, reject) => {

});
}
return new Promise((resolve, reject) => {
Request.post(
'/usercenter/weixinmp/jsapi/v1',
{
url: window.location.href.split('#')[0],
},
).then((res) => {
if (res.ret && res.data) {
resolve(res.data);
} else {
reject(res.data);
}
});
});
};

const wxLogin = (redirectUrl, param, apiScope) => {
try {
const wxBaselink = 'https://open.weixin.qq.com/connect/oauth2/authorize';
const deviceId = Device.getDeviceId();
const urlPrefix = IS_PROD ? 'https://api.bianlifeng.com' : 'http://b1.api.wormpex.com';
const finalUrl = encodeURIComponent(`${urlPrefix}/usercenter/weixinmp/login/v1?deviceid=${deviceId}&redirectUrl=${encodeURIComponent(redirectUrl)}&param=${JSON.stringify(param || {})}`);
/**
* [get More](http://wiki.corp.bianlifeng.com/pages/viewpage.action?pageId=8135692)
* [WeChat](https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421140842)
*/
const appid = IS_PROD ? 'wxddfa9205e94a24db': 'wx188265647466d243';
const redirect_uri = finalUrl;
const response_type = 'code';
const scope = apiScope || 'snsapi_base';
const wxLoginLink =  `${wxBaselink}?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}`;
return wxLoginLink;

} catch (error) {
console.log(error);
}
}

const newLogin = (redirectUrl, param, apiScope) => {
try {
const wxBaselink = 'https://open.weixin.qq.com/connect/oauth2/authorize';
const deviceId = Device.getCacheId();
const urlPrefix = IS_PROD ? 'https://api.bianlifeng.com' : 'http://wormpex.com';
const finalUrl = encodeURIComponent(`${urlPrefix}/usercenter/weixinmp/login/v1?deviceid=${deviceId}&redirectUrl=${encodeURIComponent(redirectUrl)}&param=${JSON.stringify(param || {})}`);
/**
* [get More](http://wiki.corp.bianlifeng.com/pages/viewpage.action?pageId=8135692)
* [WeChat](https://mp.weixin.qq.com/wiki?t=resource/res_main&id=mp1421140842)
*/
const appid = IS_PROD ? 'wxddfa9205e94a24db': 'wx188265647466d243';
const redirect_uri = finalUrl;
const response_type = 'code';
const scope = apiScope || 'snsapi_base';
return `${wxBaselink}?appid=${appid}&redirect_uri=${redirect_uri}&response_type=${response_type}&scope=${scope}#wechat_redirect`;
} catch (error) {
console.log(error);
}
}

const share = (data) => {
wx.config({
debug: false,
appId: data.appid,
timestamp: data.timestamp,
nonceStr: data.noncestr,
signature: data.signature,
jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'scanQRCode', 'getLocation', 'closeWindow'],
});
wx.ready(() => {
const title = data.title || '便利蜂无人值守货架，承包你的一日三餐！';
const desc = data.desc || '办公室必备，尽享便利，小小幸福在你身边';
const link = data.link || location.origin + '/jack/pages/invitation/';
const imgUrl = data.imgUrl || location.origin + '/jack/static/img/logo.png';
const onSuccess = data.onSuccess || (() => { });
const onCancel = data.onCancel || (() => { });

wx.onMenuShareTimeline({
title: title,
link: link,
imgUrl: imgUrl,
success: function () {

onSuccess({
status: 'success',
channel: 'weixin_circle'
});
},
cancel: function () {

onCancel();
}
});


wx.onMenuShareAppMessage({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success() {
onSuccess({
status: 'success',
channel: 'weixin'
});
},
cancel() {
onCancel();
},
});


wx.onMenuShareQQ({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

onSuccess({
status: 'success',
channel: 'qq'
});
},
cancel: function () {

onCancel();
}
});


wx.onMenuShareQZone({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

onSuccess({
status: 'success',
channel: 'qzone',
});
},
cancel: function () {

onCancel();
}
});
});
};

const newShare = (data) => {
getAppId().then((config)=>{
window.wx.config({
debug: false,
appId: config.appid,
timestamp: config.timestamp,
nonceStr: config.noncestr,
signature: config.signature,
jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage', 'onMenuShareQQ', 'onMenuShareQZone', 'scanQRCode', 'getLocation', 'closeWindow'],
});
window.wx.ready(() => {
const title = data.title || '便利蜂无人值守货架，承包你的一日三餐！';
const desc = data.desc || '办公室必备，尽享便利，小小幸福在你身边';
const link = data.link || location.origin + '/jack/pages/invitation/';
const imgUrl = data.imgUrl || location.origin + '/jack/static/img/logo.png';
const onSuccess = data.onSuccess || (() => { });
const onCancel = data.onCancel || (() => { });

window.wx.onMenuShareTimeline({
title: title,
link: link,
imgUrl: imgUrl,
success: function () {

onSuccess({
status: 'success',
channel: 'weixin_circle'
});
},
cancel: function () {

onCancel();
}
});


window.wx.onMenuShareAppMessage({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success() {
onSuccess({
status: 'success',
channel: 'weixin'
});
},
cancel() {
onCancel();
},
});


window.wx.onMenuShareQQ({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

onSuccess({
status: 'success',
channel: 'qq'
});
},
cancel: function () {

onCancel();
}
});


window.wx.onMenuShareQZone({
title: title,
desc: desc,
link: link,
imgUrl: imgUrl,
success: function () {

onSuccess({
status: 'success',
channel: 'qzone',
});
},
cancel: function () {

onCancel();
}
});
});
})
};

const getGPS=()=>{
if (!isWechat()) {
return new Promise((resolve, reject) => {

});
}
return new Promise((resolve, reject) => {
getAppId().then((configData) => {
window.wx.config({
debug: false,
appId: configData.appid,
timestamp: configData.timestamp,
nonceStr: configData.noncestr,
signature: configData.signature,
jsApiList,
});
window.wx.ready(() => {
window.wx.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success(res) {
const latitude = res.latitude; 
const longitude = res.longitude; 
resolve({
latitude,longitude,
})
},
fail(){
reject();

},
cancel(){
reject();
}
});
})
}).catch((e) => {
console.log(e);
reject(e);
});
})
}

const getLocation=()=>{
if (!isWechat()) {
return new Promise((resolve, reject) => {

});
}
return new Promise((resolve, reject) => {
getAppId().then((configData) => {
wx.config({
debug: false,
appId: configData.appid,
timestamp: configData.timestamp,
nonceStr: configData.noncestr,
signature: configData.signature,
jsApiList,
});
wx.ready(() => {
wx.getLocation({
type: 'gcj02', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
success(res) {
const latitude = res.latitude; 
const longitude = res.longitude; 
resolve({
latitude,longitude,
})
},
fail(e){
reject(e);

},
cancel(){
reject();
}
});
})
}).catch((e) => {
console.log(e);
reject(e);
});
})
}

const updateShare=(config)=>{
console.log('获取到图片updateShare')
if (!isWechat() || !window.wx.updateAppMessageShareData) {
return new Promise((resolve, reject) => {

});
}
return new Promise((resolve, reject) => {
getAppId().then((configData) => {
console.log('获取到图片 config')
window.wx.config({
debug: false,
appId: configData.appid,
timestamp: configData.timestamp,
nonceStr: configData.noncestr,
signature: configData.signature,
jsApiList,
});
window.wx.ready(() => {
console.log('获取到图片 updateAppMessageShareData')
window.wx.updateAppMessageShareData({
title: config.title || '蜂拼团', // 分享标题
desc: config.desc, // 分享描述
link: config.link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
imgUrl: config.imgUrl, // 分享图标
success(res) {
resolve()
console.log('分享成功')
},
fail(){
reject();
console.error('分享信息更新失败')

},
cancel(){
reject();
}
});
})
}).catch((e) => {
console.log(e);
reject(e);
});
})
}

const hideAllNonBaseMenuItem=(config)=>{
if (!isWechat() || !window.wx.hideAllNonBaseMenuItem) {
return new Promise((resolve, reject) => {

});
}
return new Promise((resolve, reject) => {
getAppId().then((configData) => {
window.wx.config({
debug: false,
appId: configData.appid,
timestamp: configData.timestamp,
nonceStr: configData.noncestr,
signature: configData.signature,
jsApiList,
});
window.wx.ready(() => {
window.wx.hideAllNonBaseMenuItem();
})
}).catch((e) => {
console.log(e);
reject(e);
});
})
}

const showAllNonBaseMenuItem=()=>{
if (!isWechat() || !window.wx.showAllNonBaseMenuItem) {
return new Promise((resolve, reject) => {

});
}
return new Promise((resolve, reject) => {
getAppId().then((configData) => {
window.wx.config({
debug: false,
appId: configData.appid,
timestamp: configData.timestamp,
nonceStr: configData.noncestr,
signature: configData.signature,
jsApiList,
});
window.wx.ready(() => {
window.wx.showAllNonBaseMenuItem();
})
}).catch((e) => {
console.log(e);
reject(e);
});
})
}

export default {
getAppId,
share,
isWechat,
wxLogin,
getGPS,
getLocation,
updateShare,
newLogin,
newShare,
hideAllNonBaseMenuItem,
showAllNonBaseMenuItem,
jsApiList,
};



// WEBPACK FOOTER //
// ./src/utils/Wechat/index.js